<template>
  <div class="component-left-container card-background" style="height: 100%">
    <el-card style="height: 100%">
      <div slot="header" class="clearfix">
        <div class="header flex items-center justify-between">
          <!-- <i
            class="el-icon-first-aid-kit"
            style="font-size: 26px; color: #4bace0"
          ></i> -->
          <div class="cc-header flex justify-around items-center p-0">
            <dv-decoration-1 style="width: 100px; height: 20px" />
            <div class="font-bold" style="font-size: 26px; color: #333">
              <!-- {{ data && data.name }} -->
              医疗小常识
              <!-- {{ data.modules[0].name && data.name }} -->
            </div>
            <dv-decoration-1 style="width: 100px; height: 20px" />
          </div>

          <div>
            <Pagination
              @changePage="onChangePage"
              :total="data && data.total"
              :pageSize="data.query && data.query.pageSize"
              :page="data.query && data.query.page"
            ></Pagination>
          </div>
        </div>
      </div>
      <div class="list-container">
        <div
          v-for="item in data.list"
          :key="item.id"
          @click="handleClickItem(item)"
          class="item-container cursor-pointer"
        >
          <el-image
            style="width: 100px; height: 100px"
            :src="item.cover[0]"
            fit="cover"
          ></el-image>
          <div class="right-title">
            {{ item.title }}
          </div>
        </div>
      </div>
    </el-card>
    <NoticeDialog :show.sync="visible" :detail="detail"></NoticeDialog>
  </div>
</template>
<script>
import Pagination from "../../Components/Pagination.vue";
import NoticeDialog from "../../Components/NoticeDialog.vue";

export default {
  data() {
    return {
      visible: false,
      detail: {},
    };
  },
  components: {
    Pagination,
    NoticeDialog,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    onChangePage(page) {
      this.$emit("onChangePage", {
        ...this.data.query,
        page,
        index: this.data.index,
      });
    },
    handleClickItem(item) {
      this.detail = item;
      this.visible = true;
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep {
  .el-card {
    background-color: transparent !important;
  }
}
.component-left-container {
  color: #333 !important;
  .list-container {
    overflow: scroll;
    height: calc(100vh - 280px);
  }
  .item-container {
    display: flex;
    align-items: center;
    border-bottom: 1px solid @border-color;
    padding: 10px 0;
    .right-title {
      width: 80%;
      margin-left: 10px;
      font-size: 20px;
    }
  }
}
</style>
